export default "/fonts/vendor/mdui/dist/icons/material-icons/MaterialIcons-Regular.woff?83bebaf37c09c7e1c3ee52682892ae14";